const handlers = {
    logoutModal: {
        open: 'modals_open_logoutModal',
        close: 'modals_close_logoutModal'
    }
};

const initVuexState = function(state) {
    state.modals = state.modals || {};
    state.modals.logout = {
        isActive: false,
        onSuccess: null,
        onCancel: null
    };
};

const initGetters = function(getters) {
    getters.modals = getters.modals || (state => state.modals);
};

const initActions = function(actions) {
    actions[handlers.logoutModal.open] = ({ commit }) =>
        new Promise((resolve, reject) => commit(handlers.logoutModal.open, { resolve, reject }));
    actions[handlers.logoutModal.close] = ({ commit }, error) => commit(handlers.logoutModal.close, { error });
};

const initMutations = function(mutations) {
    mutations[handlers.logoutModal.open] = (state, { resolve, reject }) => {
        state.modals.logout.isActive = true;
        state.modals.logout.onSuccess = resolve;
        state.modals.logout.onCancel = reject;
    };
    mutations[handlers.logoutModal.close] = (state, { error }) => {
        state.modals.logout.isActive = false;
        if (error) state.modals.logout.onCancel(error);
        else state.modals.logout.onSuccess();
    };
};

const initAppState = function(appState, store) {
    appState.modals = appState.modals || {};
    (appState.modals.logout = {
        isActive: () => store.getters.modals.logout.isActive,
        open: () => store.dispatch(handlers.logoutModal.open),
        close: error => store.dispatch(handlers.logoutModal.close, error)
    }),
        // for backward compatibility with legacy modal calls
        (appState.modals.openLogoutModal = () => store.dispatch(handlers.logoutModal.open));
    appState.modals.closeLogoutModal = () => store.dispatch(handlers.logoutModal.close);
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./skins/bulmasite/data/modals/logout.js